<template>
  <v-footer :fixed="true" app>
      <div>© {{ new Date().getFullYear() }} Smolin BudgetPlan GmbH</div>
      <div id="footerNav" class="ml-2 mr-2">
        <router-link class="pr-2" v-for="(item, index) in footerItems" :key="index" :to="item.link">{{ item.title }}</router-link>
      </div>
       <cookie-law theme="dark-lime" buttonText="Akzeptieren">
         <div slot="message">
           Um unsere Webseite für Sie optimal zu gestalten und fortlaufend verbessern zu können, verwenden wir Cookies. Durch die weitere Nutzung der Webseite stimmen Sie der Verwendung von Cookies zu.
            Weitere Informationen zu Cookies erhalten Sie in unserer <router-link to="privacy">Datenschutzerklärung</router-link>
        </div>
       </cookie-law>
      <!-- <v-spacer></v-spacer> -->
      <!-- <PoweredByWidget>Powered by</PoweredByWidget> -->

    </v-footer>
</template>

<script>
import CookieLaw from 'vue-cookie-law'
import PoweredByWidget from '../widgets/PoweredByWidget'

export default {
  components: {
    PoweredByWidget,
     CookieLaw
  },
  data () {
    return {
      footerItems: [{
        icon: '',
        title: 'Impressum',
        link: 'legal'
      },
      {
        icon: '',
        title: 'Datenschutz',
        link: 'privacy'
      }
      ]
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/partials/FooterPartial.vue